import type { FloatingNotchMetrics } from './types';

const DEFAULT_NOTCH_TOLERANCE = 0.5;

export const isSameFloatingNotch = (
  previous: FloatingNotchMetrics | null | undefined,
  next: FloatingNotchMetrics,
  tolerance = DEFAULT_NOTCH_TOLERANCE,
): boolean => {
  if (!previous) {
    return false;
  }

  return (
    Math.abs(previous.width - next.width) < tolerance &&
    Math.abs(previous.height - next.height) < tolerance &&
    Math.abs(previous.centerX - next.centerX) < tolerance
  );
};
